import React from 'react';
import { useSelector } from 'react-redux';
import FilterableTable from '../filters/FilterableTable';
import { findAllProductCategorysPageable } from '../../actions/productCategory';
import ProductCategoryRow from './ProductCategoryRow';

const ProductCategoryTable = ({
  dispatch,
  updateProductCategory,
  deleteProductCategory,
  clearValidationErrors,
}) => {
  const productCategoryReducer = useSelector((state) => state.productCategory);
  const { productCategoryList, totalElements } = productCategoryReducer;

  let productCategoryNameList = productCategoryList.map((category, index) => (
    <ProductCategoryRow
      key={category.id}
      category={category}
      deleteProductCategory={deleteProductCategory}
      updateProductCategory={updateProductCategory}
      dispatch={dispatch}
      clearValidationErrors={clearValidationErrors}
      productCategoryReducer={productCategoryReducer}
    />
  ));

  const columns = [
   
    {
      id: 'Kategorija proizvoda',
      name: 'Kategorija proizvoda',
      filter: {
        field: 'productCategoryName',
        value: '',
        type: 'LIKE',
      },
    },
    { id: 'Измена', name: 'Измена' },
    { id: 'Брисање', name: 'Брисање' },
  ];

  return (
    <>
      <FilterableTable
        tableStyle="table-container-with-row-below"
        columns={columns}
        action={findAllProductCategorysPageable}
        rows={productCategoryNameList}
        totalElements={totalElements}
        filterPosition
      ></FilterableTable>
    </>
  );
};

export default ProductCategoryTable;
